import React from 'react';
import { MailQuestionIcon, TrendingDownIcon } from 'lucide-react';
import { NegativeCompLoan } from '../../types/commission';
import { formatPct, formatUsd } from '../../utils/format';
import { Badge } from '../sf/Badge';
import { Card } from '../sf/Card';
import { NewBadge } from '../sf/NewBadge';
import { OpenQuestionBadge } from '../sf/OpenQuestionBadge';
export function NegativeCompCard({
  loans
}: {
  loans: NegativeCompLoan[];
}) {
  return <Card title={`Negative comp loans (${loans.length})`} icon={TrendingDownIcon} iconBg="#FE9339" meta="Main: comp % < 0 → Adjusted Loan Amount $0.00." bodyClassName="" data-id="element-662" data-mp="m6a4gcdxe3t0">
      <p className="flex flex-wrap items-center gap-2 border-t border-sf-border px-4 py-2 text-xs text-sf-weak" data-id="element-663" data-mp="v2refcajzvn6">
        <NewBadge label="NEW / requested" data-id="element-664" data-mp="2ww8oemm5p8l3" />
        Main already shows $0.00 adjusted for negative comp. The flat $500 LO / $250 TL amount is still NEW / requested and not applied.
      </p>
      <ul className="divide-y divide-sf-border border-t border-sf-border" data-id="element-665" data-mp="2swzv1iv13cq2">
        {loans.map(loan => <li key={loan.loanNumber} className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 px-4 py-3" data-id="element-666" data-mp="34e8pot00h3lo">
            <div className="min-w-0" data-id="element-667" data-mp="39dlmo6kljr1z">
              <p className="flex flex-wrap items-center gap-2 text-[13px]" data-id="element-668" data-mp="39cjyd0ekl82b">
                <span className="font-semibold text-sf-blue" data-id="element-669" data-mp="3e4k1t2tumj3n">{loan.loanNumber}</span>
                <span className="text-sf-weak" data-id="element-670" data-mp="3j3ewb216hw3l">
                  · {loan.borrower} · {loan.loanOfficer} · {loan.branch}
                </span>
                <Badge tone="warning" data-id="element-671" data-mp="3n3femxreerfx">Negative comp</Badge>
              </p>
              <p className="mt-0.5 text-xs tabular-nums text-sf-weak" data-id="element-672" data-mp="3s3juclkhfi53">
                {formatUsd(loan.loanAmount)} × {formatPct(loan.totalCompPct)} = {formatUsd(loan.revenue)} − {formatUsd(loan.feeShort)} fee short (halved) ={' '}
                <span className="font-semibold text-sf-red" data-id="element-673" data-mp="1xrmxgd39tk2n">{formatUsd(loan.revenueAfterShort)}</span>
              </p>
              <p className="text-xs text-sf-weak" data-id="element-674" data-mp="22qq421ywfycq">Revenue after fee short is negative → comp % &lt; 0 → Adjusted Loan Amount $0.00 (main)</p>
              <p className="mt-1 flex flex-wrap items-center gap-1.5 text-xs text-sf-weak" data-id="element-675" data-mp="1qndppkuft9gh">
                <MailQuestionIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-676" data-mp="24mwmjhhssydh" />
                Proposed alert · Recipients: to be confirmed (open question)
                <OpenQuestionBadge data-id="element-677" data-mp="1zpd6qd5gcdjf" />
              </p>
            </div>
            <div className="text-right" data-id="element-678" data-mp="2dlqntl62qcxd">
              <p className="text-xs text-sf-weak" data-id="element-679" data-mp="2dkp3sr72yg3i">Adjusted Loan Amount</p>
              <p className="font-semibold tabular-nums" data-id="element-680" data-mp="29l7ufmoj8yt2">{formatUsd(loan.adjustedAmount)}</p>
              <p className="text-[11px] text-sf-weak" data-id="element-681" data-mp="2ncd0p7meopcd">comp % &lt; 0 (main)</p>
            </div>
          </li>)}
      </ul>
    </Card>;
}